import React, { useState, useEffect } from "react";
import { ApproveBank} from "../../pages";
import { WalletController } from "../../controllers";

const ApproveBankContainer = () => {
    const [loading, setLoading] = useState(false);
    const [approveRequestModal, setApproveRequestModal] = useState(false);
    const [requestData, setRequestData] = useState({})

    useEffect(() => {        
        const setWallet = async () => {   
            setLoading(true)              
            await Promise.all([
                WalletController.getAccountCreateRequests(),
            ])
            setLoading(false);
        }
        setWallet();
    }, [])

    const goToApproveRequest = (item) => {
        setApproveRequestModal(true);
        setRequestData(item)
    }

    const closeModal = () => {
        setApproveRequestModal(false);
    }

    return (
        <ApproveBank
            goToApproveRequest={goToApproveRequest}
            loading={loading}
            closeModal={closeModal}
            approveRequestModal={approveRequestModal}
            requestData={requestData}          
        />
    )
}
export default ApproveBankContainer;